// src/app/features/admin/store/admin.selectors.ts

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AdminState } from './admin.state';

export const ADMIN_FEATURE_KEY = 'admin';

export const selectAdminState = createFeatureSelector<AdminState>(ADMIN_FEATURE_KEY);

// ── Users ───────────────────────────────────────────────────────────
export const selectAdminUsers        = createSelector(selectAdminState, s => s.users);
export const selectAdminUsersData    = createSelector(selectAdminUsers, s => s.data ?? []);
export const selectAdminUsersLoading = createSelector(selectAdminUsers, s => s.loading);
export const selectAdminLastFilter   = createSelector(selectAdminState, s => s.lastFilter);

// ── Branches ────────────────────────────────────────────────────────
export const selectAdminBranches        = createSelector(selectAdminState, s => s.branches);
export const selectAdminBranchesData    = createSelector(selectAdminBranches, s => s.data ?? []);
export const selectAdminBranchesLoading = createSelector(selectAdminBranches, s => s.loading);

// ── User Detail (keyed) ─────────────────────────────────────────────
export const selectAdminUserDetailMap = createSelector(selectAdminState, s => s.userDetail);
export const selectAdminUserDetailFor = (userId: number) =>
  createSelector(selectAdminUserDetailMap, m => m[userId] ?? null);
